/**
 * The "?" on a screen opens the topic that explains that screen. One table
 * for web and app, so the same screen leads to the same help on both.
 * help.test.ts checks that every target exists.
 */
export const CONTEXT_HELP = {
  login: 'anmelden',
  tenants: 'vereine-wechseln',
  fleet: 'flotte',
  plan: 'lageplan',
  report: 'schaden-melden',
  detail: 'schaden-detail',
  search: 'suche',
  inbox: 'eingang',
  profile: 'erste-schritte',
  myReports: 'meine-meldungen',
  adminMembers: 'mitglieder',
  adminFleet: 'flotte-verwalten',
  adminSettings: 'einstellungen',
  adminProtocol: 'protokoll',
  adminTrash: 'papierkorb',
  adminClub: 'verein',
  privacy: 'datenschutz',
} as const satisfies Record<string, string>;

export type HelpScreen = keyof typeof CONTEXT_HELP;
